import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "alerts" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Alert = _resolveComponent("Alert")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { duration: 500 }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert) => {
          return (_openBlock(), _createBlock(_component_Alert, {
            key: alert.id,
            type: alert.type,
            text: alert.text,
            time: alert.time,
            action: !!alert.action,
            actionText: alert.actionText,
            onClose: ($event: any) => (_ctx.close(alert.id)),
            onAction: ($event: any) => (_ctx.action(alert.id)),
            class: "alert-wrap",
            onMouseover: ($event: any) => (_ctx.cancelAutoRemove(alert.id))
          }, null, 8, ["type", "text", "time", "action", "actionText", "onClose", "onAction", "onMouseover"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}